import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-processing",
  "use": "icon-processing-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-processing\">\n<circle cx=\"10\" cy=\"10\" r=\"9.5\" stroke=\"#1890FF\" />\n<circle cx=\"10\" cy=\"10\" r=\"4\" fill=\"#1890FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol